// src/components/YourPath/RutasDidacticasEditStep1.js
import React from "react";
import { Form, Button, Dropdown, TextArea } from "semantic-ui-react";
import {
  Form as AntForm,
  Input,
  Select,
  Button as AntBtn,
  Typography,
} from "antd";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import { validationSchema } from "../RutasDidacticasForm/RutasDidacticasForm.form";
import { NEW_SALAS } from "../../../../ui/featureFlags";

// Importamos el SCSS que crearemos a continuación
import "./RutasDidacticasEditStep1.scss";
import "../RutasDidacticasForm/RutasStep.scss";

export function RutasDidacticasEditStep1({
  route,
  teacher,
  onUpdateRoute,
  onClose,
  onNext,
}) {
  const { t } = useTranslation("itineraries");
  // Generar opciones de "classNumber" a partir de teacher.classrole
  const classOptions = (teacher?.classrole || []).map((item) => ({
    key: item.classnumber,
    text: item.classnumber,
    value: item.classnumber,
  }));

  // useFormik para manejar el formulario
  const formik = useFormik({
    initialValues: {
      nameRute: route?.nameRute || "",
      description: route?.description || "",
      classnumber: route?.classnumber || "",
    },
    validationSchema: validationSchema(t),
    validateOnChange: false,
    // Al hacer submit, solo guardamos los datos y avanzamos
    onSubmit: (values) => {
      // Actualiza la ruta en el Wizard (no llama a la API)
      onUpdateRoute(values);
      onNext();
    },
  });

  const getError = (field) =>
    formik.errors?.[field] ? String(formik.errors[field]) : null;

  if (NEW_SALAS) {
    const antClassOptions = classOptions.map((o) => ({
      label: o.text,
      value: o.value,
    }));
    return (
      <div className="rutas-step rutas-step1">
        <Typography.Title level={4} className="rutas-step__title">
          {t("editStep1.title")}
        </Typography.Title>

        <AntForm layout="vertical" onFinish={() => formik.handleSubmit()}>
          <AntForm.Item
            label={t("editStep1.nameLabel")}
            validateStatus={getError("nameRute") ? "error" : ""}
            help={getError("nameRute")}
          >
            <Input
              name="nameRute"
              size="large"
              value={formik.values.nameRute}
              onChange={formik.handleChange}
            />
          </AntForm.Item>

          <AntForm.Item
            label={t("editStep1.descLabel")}
            validateStatus={getError("description") ? "error" : ""}
            help={getError("description")}
          >
            <Input.TextArea
              name="description"
              size="large"
              rows={4}
              value={formik.values.description}
              onChange={formik.handleChange}
            />
          </AntForm.Item>

          <AntForm.Item
            label={t("editStep1.classLabel")}
            validateStatus={getError("classnumber") ? "error" : ""}
            help={getError("classnumber")}
          >
            {antClassOptions.length > 0 ? (
              <Select
                size="large"
                placeholder={t("editStep1.classPlaceholder")}
                value={formik.values.classnumber || undefined}
                options={antClassOptions}
                showSearch
                optionFilterProp="label"
                onChange={(value) => formik.setFieldValue("classnumber", value)}
              />
            ) : (
              <Input
                name="classnumber"
                size="large"
                value={formik.values.classnumber}
                onChange={formik.handleChange}
                placeholder={t("editStep1.classPlaceholder")}
              />
            )}
          </AntForm.Item>

          <div className="rutas-step__footer">
            <AntBtn size="large" onClick={onClose}>
              {t("editStep1.cancelButton")}
            </AntBtn>
            <AntBtn type="primary" size="large" htmlType="submit">
              {t("editStep1.nextButton")}
            </AntBtn>
          </div>
        </AntForm>
      </div>
    );
  }

  return (
    <div className="rutas-step1">
      <h3 className="rutas-step1__title">{t("editStep1.title")}</h3>

      <Form onSubmit={formik.handleSubmit} className="rutas-step1__form">
        <Form.Input
          label={t("editStep1.nameLabel")}
          name="nameRute"
          value={formik.values.nameRute}
          onChange={formik.handleChange}
          error={
            formik.errors.nameRute
              ? { content: formik.errors.nameRute, pointing: "above" }
              : null
          }
          className="rutas-step1__field"
        />

        <Form.Field
          control={TextArea}
          label={t("editStep1.descLabel")}
          name="description"
          value={formik.values.description}
          onChange={formik.handleChange}
          error={
            formik.errors.description
              ? { content: formik.errors.description, pointing: "above" }
              : null
          }
          className="rutas-step1__field"
        />

        <Form.Field
          error={!!formik.errors.classnumber}
          className="rutas-step1__field"
        >
          <label className="rutas-step1__label">
            {t("editStep1.classLabel")}
          </label>
          <Dropdown
            placeholder={t("editStep1.classPlaceholder")}
            fluid
            selection
            options={classOptions}
            value={formik.values.classnumber}
            onChange={(_, { value }) =>
              formik.setFieldValue("classnumber", value)
            }
            className="rutas-step1__dropdown"
          />
          {formik.errors.classnumber && (
            <div className="rutas-step1__error">
              {formik.errors.classnumber}
            </div>
          )}
        </Form.Field>

        <div className="rutas-step1__buttons">
          <Button type="submit" primary className="rutas-step1__btn">
            {t("editStep1.nextButton")}
          </Button>
          <Button type="button" onClick={onClose} className="rutas-step1__btn">
            {t("editStep1.cancelButton")}
          </Button>
        </div>
      </Form>
    </div>
  );
}
